module.exports = __webpack_public_path__ + "media/icon_transaction/hedgehog-8db58db3.png";